import * as React from 'react';
import { observer } from 'mobx-react';
import { observable, when } from 'mobx';
import { RouteComponentProps } from 'react-router';

import { Permissions } from '@app/AppConstants';

import { securityService } from '@app/Services/SecurityService';
import PersonStore from '@app/Stores/PersonStore';
import { navigationStore } from '@app/Stores/NavigationStore';

import { Sidebar } from '@app/Components/Sidebar';
import { AzureAuth } from '@app/Components/AzureAuth';
import { PersonInfo } from '@app/Pages/PersonInfo/PersonInfo';

@observer
export class Home extends React.Component<RouteComponentProps<{}> & {}, {}> {

    private _personStore: PersonStore;
    @observable personCode: string | null = null;
    
    constructor(props: RouteComponentProps<{}> & {}){
        super(props);
        this._personStore = new PersonStore();
    }

    async componentDidMount() {
        await this._personStore.loadPersons();
        this.reactOnParamsReceive(this.props);
    }

    componentWillReceiveProps(nextProps: RouteComponentProps<{}> & {}) {
        this.reactOnParamsReceive(nextProps);
    }
    
    private reactOnParamsReceive(props: RouteComponentProps<{}> & {}){
        const params = props.match.params as IPersonInfoParams;
        if(params && params.code && params.code !== this.personCode){
            this.personCode = params.code;
            when(() => this._personStore.dataLoading.isCompleted, () =>{
                this._personStore.selectPersonByCode(params.code);
                if(params.code && !this._personStore.selectedPerson){
                    return navigationStore.redirect('/not-found-person?code=' + params.code);
                }
            });
        }
    }

    componentWillUnmount() {
        this._personStore.selectedPersonId = null;
    }
    
    render() {
        return (
            <>
		        {securityService.hasPermission(Permissions.ViewPersonsList, !AzureAuth.isUserOnlyInCrewGroup) && <Sidebar personStore={this._personStore}/>}
                {this._personStore.selectedPerson && (
                    <PersonInfo 
                        personId={this._personStore.selectedPerson.id} 
                        personDepartment={this._personStore.selectedPerson.department}
                        onDeletePersonHandler={this._personStore.onDeletePersonCallback} 
                        onSendPersonToMbHandler={this._personStore.sendPersonToMb}
                    />
                )}
            </>
        );
    }
}

interface IPersonInfoParams {
    code: string;
}